Beef.module("EditBrandCrowdQuota").addInitializer(function(startupOptions) {

    this.View = Beef.SettingsDialog.View.extend({
        template: require("@/setup/crowd/EditBrandCrowdQuota.handlebars"),

        attributes: { class: "edit-brand-crowd-quota dialog" }
    });

});